import script from "./SouthboundLeaderboard.vue?vue&type=script&setup=true&lang=js"
export * from "./SouthboundLeaderboard.vue?vue&type=script&setup=true&lang=js"

import "./SouthboundLeaderboard.vue?vue&type=style&index=0&id=e86954c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e86954c0"]])

export default __exports__